export default {
	common: {
		close: "Chiudere",
	},
	checkout: {
		steps: {
			cart: "Carrello",
			addresses: "Indirizzi",
			delivery: "Consegna",
			offer: "Offerta",
		},
		back: "Indietro",
		next: "Avanti",
		cartWarning: {
			line1: "Alcuni articoli in questo carrello sono attualmente in fase di blexonizzazione, non sono ancora stati blexonizzati con l'ultima versione, oppure il prezzo è cambiato e non è ancora stato ricalcolato.",
			line2: "Ricalcoli gli articoli oppure, in caso di domande, contatti il nostro helpdesk.",
		},
		deliveryAddressTitle: "Indirizzo di consegna",
		invoiceAddressTitle: "Indirizzo di fatturazione",
		moreAddresses: "Altri indirizzi...",
		paymentType: {
			title: "Modalità di pagamento",
			text: "Le invieremo una fattura {method} a {email}.",
			digitalMethod: "elettronicamente",
			postalMethod: "per posta",
			changeAddressTooltip: "Va alle impostazioni dell'indirizzo.",
			changeAddress: "Modificare l'indirizzo",
		},
		orderNumberCard: {
			title: "Numero d'ordine",
			description: "Per questo ordine può assegnare un proprio numero d'ordine.",
			description2: "Indicheremo questo numero sul bollettino di consegna e sulla fattura.",
			placeholder: "Il Suo numero d'ordine",
		},
		notificationsCard: {
			title: "Notifiche",
			description:
				"Inviamo la conferma d'ordine e la notifica del completamento del Suo ordine al Suo indirizzo e-mail ({email}). Facoltativamente, questi messaggi possono essere inviati anche a un ulteriore indirizzo e-mail. Un valore predefinito per questo indirizzo e-mail può essere impostato nelle {link}.",
			settingsLink: "impostazioni dell'account cliente",
			additionalEmailCheckbox: "Invia i messaggi a un indirizzo supplementare",
			additionalEmailPlaceholder: "Indirizzo e-mail",
		},
		addressPicker: {
			title: "Selezionare l'indirizzo per l'ordine",
		},
	},
	offer: {
		pleaseSelect: "La preghiamo di selezionare",
		currentlyUnavailable: "Attualmente non disponibile",
		fastDelivery: "Consegna rapida",
		bestPrice: "Prezzo più conveniente",
		downloadPdfTooltip: "Scaricare l'offerta come documento PDF",
		table: {
			position: "Posizione",
			price: "Prezzo",
			deliveryDate: "Data di consegna (franco fabbrica)",
			noDatesAvailable: "Nessuna data di consegna disponibile",
			positionsInCartPlural: "{count} posizioni nel carrello",
			positionsInCartSingular: "Posizione nel carrello",
			orderDiscount: "Sconto d'ordine",
			packagingAndDelivery: "Imballaggio & consegna {type}",
			accordingToEffort: "in base all'impegno",
			invoiceByPost: "Fattura per posta",
			net: "Netto",
			vat: "IVA ({ratio}%)",
			total: "Totale (IVA incl.)",
		},
		acceptNachAufwand:
			"Sono consapevole che verranno addebitati costi supplementari per imballaggio & consegna",
		acceptAgb: "Accetto le {agb}",
		buyNowTooltip: "Ordina questa offerta in modo vincolante e a pagamento",
		buyNow: "Acquista ora",
		requestOrderTooltip:
			"L'ordine verrà inoltrato alla persona responsabile della Sua organizzazione per l'approvazione.",
		requestOrder: "Richiedi ordine",
		errors: {
			timerExpired: "Il timer dell'offerta è scaduto",
			offerInvalid:
				"L'offerta non è più valida poiché un articolo nel carrello è stato aggiornato. La preghiamo di ricalcolare l'offerta.",
			agbNotAccepted: "Le condizioni generali di contratto devono essere accettate",
			nachAufwandNotAccepted: "I costi di consegna in base all'impegno devono essere accettati",
			noDeliveryDate: "Deve essere selezionata una data di consegna",
			manufacturerNotAvailable:
				"Questa offerta non è disponibile per il ritiro in rampa presso il luogo selezionato. Scelga un altro luogo di ritiro o di consegna.",
		},
		or: "oppure",
		emailOrderTooltip:
			"Utilizzi questa opzione se preferisce ordinare via e-mail (ad es. da un sistema ERP/SAP).",
		emailOrder: "Salva offerta (ordine via e-mail)",
		emailOrderHint:
			"L'offerta viene scaricata come documento PDF. Per effettuare un ordine, ci invii il documento PDF per e-mail, ad esempio come allegato a un ordine ERP/SAP.",
		discountDialog: {
			title: "Quando ricevo lo sconto d'ordine?",
			intro: "Nel calcolo di un'offerta vengono considerate tutte le posizioni in essa contenute e viene calcolato uno sconto d'ordine.",
			factorsIntro: "I seguenti fattori portano a una {reduction}",
			priceReduction: "riduzione di prezzo:",
			factor1: "Più articoli dello stesso materiale grezzo (stesso materiale e stesso spessore di lamiera)",
			factor2: "Più articoli con le stesse lavorazioni (filettature, svasature ed estrusioni) nello stesso materiale grezzo",
			factor3: "Più articoli con lo stesso rivestimento a polvere (stessa polvere)",
			factor4: "Più articoli con la stessa zincatura",
		},
		nachAufwandDialog: {
			title: "Trasporto in base all'impegno",
			text1: "Ove possibile, calcoliamo automaticamente i costi di imballaggio e spedizione per posta o via camion.",
			text1b: "Rinunciamo volutamente alla spedizione di merce ingombrante per posta, poiché l'impegno di imballaggio per questo tipo di spedizione è solitamente sproporzionato.",
			text1c: "I pezzi grandi e/o pesanti vengono consegnati via camion. In questo caso non è sempre possibile un calcolo automatico anticipato.",
			text2: "Il prezzo dipende dall'impegno di imballaggio, dalla distanza dal luogo di consegna, dal peso dei pezzi e dalle dimensioni di tutti i pezzi dell'intera consegna.",
			text2b: "Per i pezzi di grandi dimensioni (più grandi di un pallet Europa), le dimensioni incidono notevolmente sul prezzo. La consegna diventa più cara con ogni centimetro aggiuntivo. Allo stesso tempo, è molto difficile calcolare automaticamente come i pezzi piegati possano essere impilati e quale imballaggio sia necessario per garantire un trasporto sicuro.",
			text3Bold:
				"Per le consegne in base all'impegno, Le addebitiamo quindi l'importo effettivo richiesto dal nostro spedizioniere secondo la tariffa ASTAG. Inoltre calcoliamo il tempo necessario per l'imballaggio al minuto esatto.",
			text3: "Può presumere che una consegna via camion in base all'impegno costi generalmente tra {currency} 100.- e 200.-.",
			text3b: "Per spedizioni molto grandi, ad es. più pallet Europa o spedizioni di grande superficie (lunghezza x larghezza > 200 cm x 100 cm), il prezzo può essere più elevato. In caso di dubbio, contatti il nostro helpdesk all'indirizzo {email}",
			text4: "Siamo consapevoli che per i nostri clienti è importante conoscere il prezzo finale, comprensivo di tutti i costi, prima di effettuare l'ordine. Al momento, limitazioni tecniche rendono ciò impossibile in alcuni casi. Abbiamo deciso volutamente di rinunciare a una tariffa forfettaria, poiché siamo convinti che questa soluzione sia più trasparente ed efficiente in termini di costi e rispecchi meglio la realtà.",
		},
		orderFailedDialog: {
			title: "Ordine non riuscito",
			text: "Durante il processo d'ordine si è verificato un errore.",
			text2: "Per assistenza, contatti il nostro helpdesk all'indirizzo {email}",
		},
	},
	offerInformation: {
		calculating: "La Sua offerta è in fase di calcolo...",
		calculatingHint: "I costi e le date di consegna vengono determinati insieme ai partner di produzione.",
		calculatingHint2: "In presenza di molte posizioni, l'operazione può richiedere uno o due minuti.",
		thanksForRequestTitle: "Grazie per la Sua richiesta.",
		manualOfferRequestedText:
			"Abbiamo ricevuto la Sua richiesta e Le sottoporremo un'offerta specifica per l'ordine. La preghiamo di avere pazienza durante l'elaborazione. Non appena l'offerta sarà disponibile, La informeremo via e-mail.",
		thanksForOrderTitle: "Grazie per il Suo ordine.",
		orderedDirectlyText:
			"Da ora può consultare lo stato dell'ordine nella panoramica ordini. Inoltre riceverà a breve un'e-mail di conferma.",
		thanksForOrderTitle2: "Grazie per il Suo ordine.",
		orderedIndirectlyText:
			"Le persone responsabili della Sua organizzazione verranno informate a breve via e-mail del Suo ordine. Queste persone possono, se necessario, adattare l'ordine e successivamente approvarlo. Non appena il Suo fabbisogno sarà stato ordinato, potrà consultare lo stato dell'ordine nella panoramica ordini. Riceverà inoltre allora un'e-mail di conferma.",
		backToArticlesTooltip: "Va al catalogo articoli.",
		backToArticles: "Ai miei articoli",
		offerSavedTitle: "Grazie per la Sua richiesta.",
		offerSavedText: "Il PDF della Sua offerta è stato scaricato con successo.",
		offerSavedText2:
			"Se desidera accettare la nostra offerta, ci invii il PDF per e-mail a {email}.",
		offerSavedText3:
			"Se trasmette il Suo ordine tramite un sistema ERP o SAP, La preghiamo di allegare anche il documento PDF.",
		offerSavedText4: "In questo modo possiamo elaborare la Sua richiesta in modo rapido ed efficiente.",
		countryNotServiced: "Offerta non possibile",
		countryNotServicedText: "Purtroppo al momento non riforniamo ancora clienti nel Suo paese.",
		countryNotServicedText2: "Non appena la situazione cambierà, La informeremo tramite la nostra newsletter.",
		noFertigerCanProduce:
			"Non tutte le posizioni del carrello possono essere prodotte in un unico stabilimento,",
		noFertigerCanProduce2: "poiché materiali grezzi e/o lavorazioni si escludono a vicenda.",
		noFertigerCanProduce3:
			"Di norma l'ordine può essere prodotto se le posizioni vengono suddivise di conseguenza.",
		noFertigerCanProduce4:
			"Se necessita di supporto, clicchi sul pulsante sottostante per informare il nostro helpdesk.",
		noFertigerHasDeliveryDate:
			"A causa dell'elevato carico di lavoro o di una quantità d'ordine molto alta, non è stato possibile trovare date di consegna per il Suo ordine.",
		noFertigerHasDeliveryDate2:
			"Clicchi sul pulsante sottostante se desidera ricevere un'offerta per la quantità richiesta.",
		genericFailed: "Non è stato possibile creare l'offerta.",
		genericFailed2:
			"Purtroppo si è verificato un errore durante la creazione della Sua offerta. Riprovi.",
		genericFailed3: "Se l'errore persiste, ci informi tramite il pulsante sottostante.",
		notifyHelpdeskTooltip: "Informare l'helpdesk Blexon",
		notifyHelpdesk: "Informa helpdesk",
		offerValidPlural:
			"Le Sue offerte sono valide per 15 minuti. Una volta scaduta la validità, può avviare un nuovo calcolo.",
		offerValidSingular:
			"La Sua offerta è valida per 15 minuti. Una volta scaduta la validità, può avviare un nuovo calcolo.",
		recalculate: "Ricalcola",
		helpdeskDialog: {
			title: "Informare l'helpdesk Blexon",
			text: "Il nostro helpdesk verrà informato della situazione e La contatterà il prima possibile al seguente indirizzo.",
			emailLabel: "E-mail per le notifiche",
			cancelTooltip: "Annulla l'azione",
			okButton: "Ok",
			okTooltip: "Informa helpdesk",
		},
		messages: {
			helpdeskInformed: "L'helpdesk è stato informato.",
			helpdeskInformError: "Non è stato possibile informare l'helpdesk.",
		},
	},
	delivery: {
		title: "Tipo di consegna",
		question: "In che modo desidera ricevere i pezzi in lamiera?",
		producedBy: "Prodotto da: {name}",
		deliveryOption: "Consegnato (1-2 giorni dalla data di consegna)",
		rampeOption: "Ritiro in rampa (non imballato)",
		fertigerLoadError: "Non è stato possibile caricare i produttori.",
		selectionRequired: "La preghiamo di selezionare un luogo per il ritiro in rampa.",
		addressDialog: {
			title: "Indirizzo per il ritiro in rampa",
			phoneLabel: "Tel.:",
		},
		notPossibleDialog: {
			title: "Ritiro in rampa non possibile",
			text: "Purtroppo il ritiro di questo ordine non è possibile presso questo partner di produzione. È possibile che questo partner di produzione non offra il ritiro in rampa, oppure che un materiale o una lavorazione non siano disponibili.",
		},
	},
	summary: {
		chooseOffer: "Scelga la Sua offerta",
		yourOffer: "La Sua offerta",
	},
	manualOffer: {
		title: "{bold} Produzione automatizzata & interessanti sconti di quantità",
		titleBold: "Approfitti ora:",
		intro: "Il Suo carrello contiene quantità e/o materiali che Le danno diritto a uno {discount}.",
		discountHighlight: "sconto di quantità",
		text2: "Per quantitativi più elevati, l'acquisto del materiale può essere organizzato in modo più efficiente e la produzione può essere automatizzata {savings}",
		savingsHighlight: "– questo riduce notevolmente i costi!",
		text3: "Il nostro partner di produzione esamina la Sua richiesta entro 1-2 giorni lavorativi e Le sottopone un'offerta di sconto di quantità individuale, adattata alle Sue esigenze.",
		text4: "In generale vale quanto segue: più tempo ci concede per la produzione, tanto più interessante sarà lo sconto di quantità.",
		callToAction: "Richieda un'offerta ora e ne approfitti!",
		chooseDeliveryDate: "La preghiamo di selezionare la data di consegna più tardiva (franco fabbrica).",
		deliveryDateLabel: "Data di consegna più tardiva",
		noDatesAvailable: "Nessuna data di consegna disponibile",
		requestOfferTooltip: "Richiedi offerta",
		requestOffer: "Richiedi offerta",
		restrictionHint: "Questa scelta è possibile solo in caso di consegna o ritiro in rampa a {town}.",
	},
};
